import {gql} from '@apollo/client'

export const GET_INVENTORY_LIST = gql`
  query GetInventoryList($orderBy: String, $searchText: String, $locationIds: [UUID]) {
    searchInventories(orderBy: $orderBy, searchText: $searchText, locationIds: $locationIds) {
      nodes {
        id
        productId
        productName
        variantName
        sku
        inventoryItemId
        available
        imageSrc
        locations
      }
      totalCount
    }
  }
`

export const UPDATE_INVENTORY = gql`
  mutation UpdateInventory($input: UpdateInventoryInput!) {
    updateInventory(input: $input) {
      clientMutationId
    }
  }
`
export const REMOVE_INVENTORY = gql`
  mutation RemoveInventory($input: RemoveInventoryInput!) {
    removeInventory(input: $input) {
      clientMutationId
    }
  }
`

export const GET_PRODUCT_TAGS = gql`
  query GetProductTags {
    products {
      nodes {
        tags
      }
    }
  }
`
export const GET_INVENTORY_NOTES = gql`
  query GetInventoryNotes($inventoryItemId: UUID!, $first: Int, $offset: Int) {
    inventoryNotes(
      condition: {inventoryItemId: $inventoryItemId}
      orderBy: CREATED_AT_DESC
      first: $first
      offset: $offset
    ) {
      nodes {
        id
        createdAt
        description
        originalQuantity
        quantity
        action
        locationId
      }
      totalCount
    }
  }
`
export const ADD_INVENTORIES = gql`
  mutation AddInventories($input: AddInventoriesInput!) {
    addInventories(input: $input) {
      clientMutationId
    }
  }
`
export const REMOVE_INVENTORIES = gql`
  mutation RemoveInventories($input: RemoveInventoriesInput!) {
    removeInventories(input: $input) {
      clientMutationId
    }
  }
`
export const UPDATE_INVENTORIES = gql`
  mutation UpdateInventories($input: UpdateInventoriesInput!) {
    updateInventories(input: $input) {
      clientMutationId
    }
  }
`
export const GET_LOCATIONS = gql`
  query GetLocations {
    locations {
      nodes {
        id
        name
        isDefault
      }
    }
  }
`

export const ADD_INVENTORY = gql`
  mutation AddInventory($input: AddInventoryInput!) {
    addInventory(input: $input) {
      clientMutationId
    }
  }
`
